import {
  project1Laptop,
  project1Mobile,
  project2Laptop,
  project2Mobile,
  project3Laptop,
  project3Mobile,
  project4Laptop,
  project4Mobile,
 
} from "./projectImages";

export const projectData = [
  {
    id: 1,
    image: project1Laptop,
    transitionImage: project1Mobile,
    title: "Flipkart Clone",
    codeLink: "https://github.com/Sukantad/Flipkart-Clone",
    liveLink: "https://flipkart-clone-project-m.netlify.app/",
    tech:"ReactJS || Redux || JSX || React Router || CSS || Chakra UI",
    desc:"Flipkart is a e-commerce platform where customer can buy products online.",
  },
  {
    id: 2,
    image: project2Laptop,
    transitionImage: project2Mobile,
    title: "Lenskart clone",
    codeLink: "https://github.com/Vikasyadav3935/Lenskart-clone",
    liveLink: "https://lenskart-clone-22.netlify.app/",
    tech:"ReactJS || Redux || JSX || React Router || CSS || Chakra UI",
    desc:"Lenskart is a eyewear e-commerce platform where customer buy eyeglasses online.",

  },
  {
    id: 3,
    image: project3Laptop,
    transitionImage: project3Mobile,
    title: "Mailtrap clone",
    codeLink: "https://github.com/anubhav1327/Mailtrap-Project-Clone",
    liveLink: "https://velvety-fox-f115af.netlify.app/",
    tech:"HTML || JAVASCRIPT || CSS || JSON Server || Netlify",
    desc:"Mailtrap is used to send emails for startup and businesses.",
  },
  {
    id: 4,
    image: project4Laptop,
    transitionImage: project4Mobile,
    title: "Meesho clone",
    codeLink: "https://github.com/Vikasyadav3935/Meesho-clone",
    liveLink: "https://drive.google.com/file/d/1qFrxLUczVEdjzgqRab1RouroASTY1BgC/view?usp=sharing",
    tech:"React-Native || JSX || JAVASCRIPT || React-Native paper || Firebase",
    desc:"Meesho clone is online ecommerce website where customer buy product online. ",
  },
  
];
